import script from "./AssetsByDepartmentReport.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsByDepartmentReport.vue?vue&type=script&setup=true&lang=js"

import "./AssetsByDepartmentReport.vue?vue&type=style&index=0&id=07446511&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07446511"]])

export default __exports__